import React from 'react'

import { getCountryNameByCode } from '@fourthwall/utils/dist/inputs'
import { useOffersByIdsQuery } from '@hooks/useOffersByIdsQuery'

import { ShippingGroupTileView } from './ShippingGroupTileView'
import { getContent } from './utils/getContent'

type ShippingGroupContainerProps = {
  name: string
  offerIds: string[]
  countries: string[]
  onEdit: () => void
  onDelete: () => void
}

export const ShippingGroupTileContainer = ({
  name,
  offerIds,
  countries,
  onEdit,
  onDelete,
}: ShippingGroupContainerProps) => {
  const { offersByIdsQuery } = useOffersByIdsQuery([offerIds])

  const getProductsContent = () => {
    const offerNames = Object.values(offersByIdsQuery.data || {}).map((offer) => offer.name)

    return getContent(offerNames)
  }

  const getCountriesContent = () => {
    const countryNames = countries.map((country) => getCountryNameByCode(country))

    return getContent(countryNames as string[])
  }

  return (
    <ShippingGroupTileView
      name={name}
      productsContent={getProductsContent()}
      productsContentLoading={offersByIdsQuery.isLoading}
      countriesContent={getCountriesContent()}
      onEdit={onEdit}
      onDelete={onDelete}
    />
  )
}
